import WashdayClientSingleton from './WashdayClientSingleton';
import type { AxiosResponse } from 'axios';
import type {
    CopySectionPayload,
    CopySectionResponse,
    CreateSectionSubcategoryPayload,
    ISection as SDKSection,
    UpdateSectionSubcategoryPayload,
} from 'washday-sdk';

export type {
    CopySectionPayload,
    CopySectionResponse,
    CreateSectionSubcategoryPayload,
    UpdateSectionSubcategoryPayload,
};

export const copySectionV2 = async (
    sectionId: string,
    data: CopySectionPayload
): Promise<AxiosResponse<CopySectionResponse>> => {
    try {
        return await WashdayClientSingleton.getInstance().sections.copy(sectionId, data);
    } catch (e) {
        console.log('ERROR copySectionV2', e);
        throw e;
    }
};

export const getSectionsV2 = async (params: {
    storeId?: string
    isActive?: string | boolean
    products?: boolean
}) => {
    try {
        return await WashdayClientSingleton.getInstance().sections.getSections(params);
    } catch (e) {
        console.log('ERROR getSectionsV2', e);
        throw e;
    }
};

export const getSectionByIdV2 = async (id: string) => {
    try {
        return await WashdayClientSingleton.getInstance().sections.getById(id);
    } catch (e) {
        console.log('ERROR getSectionByIdV2', e);
        throw e;
    }
};

export const createSectionV2 = async (data: {
    name: string;
    order: number;
    boxColor: string;
    store: string | null;
}) => {
    try {
        return await WashdayClientSingleton.getInstance().sections.create(data);
    } catch (e) {
        console.log('ERROR createSectionV2', e);
        throw e;
    }
};

export const deleteSectionByIdV2 = async (id: string) => {
    try {
        return await WashdayClientSingleton.getInstance().sections.deleteById(id);
    } catch (e) {
        console.log('ERROR deleteSectionByIdV2', e);
        throw e;
    }
};

export const updateSectionByIdV2 = async (id: string, data: {
    name?: string;
    order?: number;
    boxColor?: string;
    showInApp?: boolean,
    store?: string | null,
    product?: any
}) => {
    try {
        return await WashdayClientSingleton.getInstance().sections.updateById(id, data);
    } catch (e) {
        console.log('ERROR updateSectionByIdV2', e);
        throw e;
    }
};

export const getSectionSubcategoriesV2 = async (
    sectionId: string
): Promise<AxiosResponse<{
    data: {
        subcategories: SDKSection[];
    };
    errors?: string[];
}>> => {
    try {
        return await WashdayClientSingleton.getInstance().sections.getSubcategories(sectionId);
    } catch (e) {
        console.log('ERROR getSectionSubcategoriesV2', e);
        throw e;
    }
};

export const createSectionSubcategoryV2 = async (
    sectionId: string,
    data: CreateSectionSubcategoryPayload
) => {
    try {
        return await WashdayClientSingleton.getInstance().sections.createSubcategory(sectionId, data);
    } catch (e) {
        console.log('ERROR createSectionSubcategoryV2', e);
        throw e;
    }
};

export const updateSectionSubcategoryV2 = async (
    sectionId: string,
    subcategoryId: string,
    data: UpdateSectionSubcategoryPayload
) => {
    try {
        return await WashdayClientSingleton.getInstance().sections.updateSubcategory(
            sectionId,
            subcategoryId,
            data
        );
    } catch (e) {
        console.log('ERROR updateSectionSubcategoryV2', e);
        throw e;
    }
};

export const deleteSectionSubcategoryV2 = async (
    sectionId: string,
    subcategoryId: string
) => {
    try {
        return await WashdayClientSingleton.getInstance().sections.deleteSubcategory(
            sectionId,
            subcategoryId
        );
    } catch (e) {
        console.log('ERROR deleteSectionSubcategoryV2', e);
        throw e;
    }
};
